import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !NO_RETRY.includes(cfg.url)) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    if (error.response?.status === 403 && error.response.data?.detail?.codigo === "cambiar_password") {
      window.dispatchEvent(new Event("auth:must-change"));
    }
    return Promise.reject(error);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ocurrió un error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.mensaje || String(d);
};
